import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { KudosTask } from "../../taskbook.types";
import { LinkPreview, GifPreview, TimelineItem, Threads } from "@teammood/timeline";

@Component({
    selector: 'kudos-task',
    templateUrl: './kudos-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KudosTaskComponent {

    @Input() task: KudosTask
    @Output() onComment = new EventEmitter()
    @Output() onReported = new EventEmitter()

    constructor(){}

    ngOnInit(): void {
        if(this.task){
        }
    }

    toGifPreview(linkPreview: LinkPreview): GifPreview {
        return new GifPreview((linkPreview));
    }

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }
    
    reportItem(){
        this.onReported.emit();
    }
}